export default "__VITE_ASSET__rIEeWpvh__"